export class UserPastell {
  public prenom: string;
  public nom: string;
  public notUSed: boolean;
  public login: string;
  constructor(data?) {
    Object.assign(this, data);
  }
}
